import styles from "./Youreko.module.scss";
import Script from "next/script";

const yourekoScriptUrl =
  "https://static.youreko.com/js/partners/gb/john-lewis/youreko.energy-review.john-lewis.all.min.js";

export const YourekoUI = () => {
  return (
    <>
      <Script src={yourekoScriptUrl} />
      <div
        data-testid="youreko-energy-rating"
        className={`youreko-placeholder ${styles.yourekoContainer}`}
      ></div>
    </>
  );
};
